import { Box } from '@mui/material';

import { TextCustomizationGroup } from './TextCustomizationGroup';

export function TextSection() {
  return (
    <Box width={'100%'}>
      <TextCustomizationGroup
        textKey={'heading'}
        title={'Heading'}
        groupBox={
          <Box width={'112px'} height={'112px'}>
            <img src='/icons/text-customization/heading.svg' alt='Heading' width={'112px'} height={'112px'} />
          </Box>
        }
      />
      <TextCustomizationGroup
        textKey={'paragraph'}
        title={'Paragraph'}
        groupBox={
          <Box width={'112px'} height={'112px'}>
            <img src='/icons/text-customization/paragraph.svg' alt='paragraph' width={'112px'} height={'112px'} />
          </Box>
        }
      />
      <TextCustomizationGroup
        textKey={'subText'}
        title={'Sub Text'}
        groupBox={
          <Box width={'112px'} height={'112px'}>
            <img src='/icons/text-customization/sub-text.svg' alt='sub-text' width={'112px'} height={'112px'} />
          </Box>
        }
      />
    </Box>
  );
}
